/**
 * Prevents layout shift when opening modals by reserving space for the scrollbar.
 * Measures scrollbar width only when the page is scrollable and applies it as
 * padding-right so body width stays constant when overflow is hidden.
 */

const SCROLLBAR_WIDTH_VAR = "--scrollbar-width";

let openCount = 0;
const registeredIds = new Set();

function lockScroll() {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    if (scrollbarWidth > 0) {
        document.body.style.setProperty(SCROLLBAR_WIDTH_VAR, `${scrollbarWidth}px`);
    }
}

function unlockScroll() {
    document.body.style.removeProperty(SCROLLBAR_WIDTH_VAR);
}

function onModalOpen() {
    openCount += 1;
    if (openCount === 1) {
        lockScroll();
    }
}

function onModalClosed() {
    openCount = Math.max(0, openCount - 1);
    if (openCount === 0) {
        unlockScroll();
    }
}

function registerModal(element) {
    const id = element.getAttribute("id");
    if (!id || registeredIds.has(id)) return;
    registeredIds.add(id);
    document.addEventListener(id, onModalOpen, true);
}

function observeModals() {
    document.querySelectorAll("body .modal").forEach(registerModal);
}

function initModalScrollLock() {
    observeModals();

    const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
            if (mutation.type === "childList") {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === Node.ELEMENT_NODE && node.classList?.contains("modal")) {
                        registerModal(node);
                    }
                });
            }
            if (mutation.type === "attributes" && mutation.attributeName === "style") {
                const el = mutation.target;
                if (el.classList?.contains("modal") && el.style?.display === "none") {
                    onModalClosed();
                }
            }
        }
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ["style"],
    });
}

export { lockScroll, unlockScroll, initModalScrollLock };
